import ButtonComponent from "./Button.Component";

export default ButtonComponent;
